import { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import cx from 'classnames';
import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import { alpha, darken } from '@classify/react-core-components/styles';

import CourseContext from '../contexts/courseContext';
import CourseMetadata from './CourseMetadata';
import FooterAction from './FooterAction';
import useCourseStatus from '../hooks/useCourseStatus';

const useStyles = makeStyles(({ spacing, breakpoints, palette }) => ({
  wrapper: {
    display: 'flex',
    padding: spacing(5, 0),
    justifyContent: 'center',
    [breakpoints.up('sm')]: {
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gridGap: spacing(3),
    },
    [breakpoints.up('md')]: {
      alignItems: 'center',
      padding: 'unset',
      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      gridGap: spacing(3),
    },
  },
  title: {
    margin: spacing(1, 0),
  },
  illustration: {
    display: 'none',
    [breakpoints.up('md')]: {
      display: 'block',
    },
  },
  content: {
    display: 'none',
    [breakpoints.up('sm')]: {
      borderRight: `1px solid ${palette.divider}`,
      paddingRight: spacing(2),
      marginRight: spacing(2),
      display: 'block',
    },
  },
  hideBorder: { border: 'none' },
}));

function CourseFooter() {
  const classes = useStyles();
  const { course } = useContext(CourseContext);
  const { isFinished } = useCourseStatus();

  const { title, illustration, categoryColor, category } = course;

  const accessibleTitleColor = darken(categoryColor, 0.05);
  const backgroundColor = alpha(categoryColor, 0.08);

  return (
    <Box sx={{ backgroundColor }}>
      <ContentWrapper>
        <div className={classes.wrapper}>
          <img src={illustration} alt="" className={classes.illustration} height="174px" />

          <div className={cx(classes.content, { [classes.hideBorder]: isFinished })}>
            <Typography
              variant="subheadingSmall"
              component="p"
              style={{ color: accessibleTitleColor, textTransform: 'uppercase' }}
            >
              {category}
            </Typography>

            <Typography variant="h4" component="h2" className={classes.title}>
              {title}
            </Typography>

            <Box>
              <CourseMetadata />
            </Box>
          </div>

          <FooterAction />
        </div>
      </ContentWrapper>
    </Box>
  );
}

export default CourseFooter;
